
// configs/allClientConfigs.js
const allClientConfigs = {
    1: {
        botName: 'Client 1 Bot',
        botUrl: 'https://atai-uat.mcndhanore.co.in/chatbot/11',
    },
    2: {
        botName: 'Client 2 Bot',
        botUrl: 'https://atai-uat.mcndhanore.co.in/chatbot/5',
    },

};

export default allClientConfigs;